export default function AccountProfileHero({ login, points }) {
    return (
        <div className="card account-page__hero">
            <p className="account-page__hero-login">@{login}</p>
            <div className="account-page__hero-balance">
                <span className="account-page__hero-balance-value">{points}</span>
                <span className="account-page__hero-balance-label">баллов</span>
            </div>
            <p className="account-page__hero-hint">
                1 балл = 1 ₽
            </p>
        </div>
    );
}
